import React from 'react';

import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper/core';
import { CommunityImage } from 'store/community/type';

SwiperCore.use([Navigation]);

const Container = styled.div`
  .mySwiper {
    margin-top: 1vw;
    --swiper-theme-color: #ede6db !important;
    max-width: 65vw;

    .swiper-wrapper {
      .swiper-slide > img {
        width: 100%;
      }
    }
  }
`;

interface IProps {
  images: Array<CommunityImage>;
  onImageClick?(): void;
}

const FeedImageSlider: React.FC<IProps> = ({
  images,
  onImageClick,
}: IProps) => {
  return (
    <Container>
      <Swiper navigation spaceBetween={30} className="mySwiper">
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image.image}
              onClick={onImageClick}
              style={{ cursor: onImageClick ? 'pointer' : 'default' }}
              alt=""
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
};

export default FeedImageSlider;
